<!-- Status Change Confirmation Dialog -->
<p-dialog
  data-testid="status-change-dialog"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  [header]="'inbound.dialog.update_status_title' | translate"
  (onHide)="onCancel()"
>
  <!-- Dialog Description -->
  <div class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
    <div class="flex items-start">
      <i class="pi pi-info-circle text-blue-600 mr-3 mt-1"></i>
      <div>
        <h4 class="text-blue-800 font-semibold mb-2">
          {{ "inbound.dialog.update_status_description_title" | translate }}
        </h4>
        <p class="text-blue-700 text-sm">
          {{ "inbound.dialog.update_status_description" | translate }}
        </p>
      </div>
    </div>
  </div>

  <!-- Item Details Table -->
  <div class="mb-4">
    <div class="flex items-center justify-between mb-3">
      <h3 class="text-lg font-semibold text-gray-800">
        {{ "inbound.sections.item_details" | translate }}
      </h3>

      <!-- Received All Checkbox -->
      <div class="flex items-center gap-2">
        <p-checkbox
          data-testid="status-change-dialog-received-all-checkbox"
          [(ngModel)]="receivedAllChecked"
          [binary]="true"
          (onChange)="onReceivedAllChange($event.checked)"
          [pTooltip]="'inbound.actions.received_all_tooltip' | translate"
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
          inputId="receivedAllCheckbox"
        ></p-checkbox>
        <label
          for="receivedAllCheckbox"
          class="text-sm font-medium text-gray-700 cursor-pointer"
        >
          {{ "inbound.actions.received_all" | translate }}
        </label>
      </div>
    </div>

    <app-data-table
      data-testid="status-change-dialog-table"
      [columns]="tableColumns"
      [dataSource]="tableData()"
      [loading]="false"
      [hasCheckColumn]="false"
      [totalRecords]="tableData().length"
      [first]="0"
      [rows]="20"
      scrollHeight="400px"
      (dataChange)="onTableDataChange($event)"
    >
      <!-- Custom template for Received All checkbox column -->
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column.prop === "receivedAll") {
          <p-checkbox
            [attr.data-testid]="'status-change-dialog-row-received-all-' + rowData.id"
            [(ngModel)]="rowData.receivedAll"
            [binary]="true"
            [disabled]="rowData.isFullyReceived"
            (onChange)="onRowReceivedAllChange($event.checked, rowData)"
            size="small"
          ></p-checkbox>
        }
      </ng-template>
    </app-data-table>
  </div>

  <!-- Validation Summary -->
  @if (statusForm.invalid && statusForm.touched) {
    <div class="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
      <div class="flex items-start">
        <i class="pi pi-exclamation-triangle text-red-600 mr-3 mt-1"></i>
        <div>
          <h4 class="text-red-800 font-semibold mb-1">
            {{ "inbound.dialog.validation_errors_title" | translate }}
          </h4>
          <ul class="text-red-700 text-sm list-disc list-inside">
            <li>
              {{ "inbound.dialog.validation_received_required" | translate }}
            </li>
            <li>{{ "inbound.dialog.validation_received_max" | translate }}</li>
            <li>{{ "inbound.dialog.validation_total_max" | translate }}</li>
          </ul>
        </div>
      </div>
    </div>
  }

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <!-- Cancel button -->
      <app-button
        [testId]="'status-change-dialog-cancel-btn'"
        label="inbound.actions.cancel"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
      ></app-button>

      <!-- Confirm button -->
      <app-button
        [testId]="'status-change-dialog-confirm-btn'"
        label="common.actions.confirm"
        type="info"
        (emitOnClick)="onConfirm()"
        [disabled]="statusForm.invalid"
      ></app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Toast Messages -->
<p-toast data-testid="status-change-dialog-toast"></p-toast>
